<!--
 * @Author: lwk
 * @Date: 2024-01-31 08:42:44
 * @LastEditors: lwk
 * @LastEditTime: 2024-03-26 10:40:38
 * @Description: 请填写简介
-->

<!--
 * @Author: 
 * @Date: 2024-01-24 09:28:09
 * @LastEditors: lwk
 * @LastEditTime: 2024-02-20 09:24:29
 * @Description: 晨会
-->
<template>
    <div style="background: rgb(246, 248, 251);height: 100vh;width: 100%;">
        <el-container>
          <el-aside width="130px">
            <el-tabs tab-position="left" style="height: 100%;" @tab-click="change_tab" v-model="tabActive">
              <el-tab-pane label="首页看板" name="0"> </el-tab-pane>
              <el-tab-pane label="结果统计" name="1"> </el-tab-pane>
            </el-tabs>
          </el-aside>
          <el-main class="mainContent" style="height: 100vh;">
            <div>
              <el-breadcrumb separator="/" style="margin-top: 10px;">
                <el-breadcrumb-item v-for="item,index in tabRlact[tabActive]" :key="index">{{ item }}</el-breadcrumb-item>
              </el-breadcrumb>
              <div style="border-bottom: 2px solid rgb(246, 248, 253);width: 100%;margin: 10px 0;"></div>
              <div v-if="tabActive == '0'">
                <HomePage/>
              </div>
              <div v-if="tabActive == '1'">
                <ResultStatic/>
              </div>
            </div>
          </el-main>
        </el-container>
    </div>
  </template>
  
  <script>
  import ResultStatic from "@/components/MeetingMinute/ResultStatic"
  import HomePage from "@/components/MeetingMinute/HomePage"
  export default {
    name: "MorningMeet",
    components: { ResultStatic,HomePage },
    data() {
      return {
        tabRlact:{
          '0':['会议纪要','首页看板'],
          '1':['会议纪要','结果统计'],
        },
        tabActive:'0'
      };
    },
    methods: {
      change_tab(val) {
        this.tabActive = val.name
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .container {
    height: 100%;
  }
  .middle {
    vertical-align: middle;
    /* height: 31px; */
    width: 126px;
    height: 50px;
  }
  .mainContent {
    background: #fff;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/MeetingMinuter.vue